import React from 'react';
import Modal from '../../../../Components/Modal/Modal';
import { Size } from '../../../../Enums/Size.enum';
import HealthPlanConfirm from '../../../HealthPlan/Components/HealthPlanCreateConfirm/HealthPlanConfirm';
import { Flyer } from '../../../EArchive/Enums/Flyer.enum';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import Confirmation from './Confirmation';

interface Props {
	title: string;
	text: string;
	imageSource?: string;
	isOpen: boolean;
	onClose: () => void;
	children?: React.ReactElement | React.ReactElement[];
	size?: Size;
}

const ConfirmationModal: React.FC<Props> = ({
	isOpen,
	onClose,
	title,
	text,
	imageSource,
	children,
	size = Size.MD,
}) => {
	const { isCase } = useTreatmentContext();

	return (
		<Modal opened={isOpen} onClose={onClose} wrapChat={isCase} size={size}>
			<Modal.Header title={title} />
			<Modal.Content contentScroll>
				<Confirmation text={text} imageSource={imageSource}>
					{children}
				</Confirmation>
			</Modal.Content>
		</Modal>
	);
};

export default ConfirmationModal;
